if(typeof BSS_B2B != undefined) {
  window.addEventListener("cart_changed", () => {
    setTimeout(() => {
      let storeData = JSON.parse($("#bss-b2b-store-data").html());
      BSS_B2B.makeChangesAfterClickAjaxCart(500)
      BSS_B2B.cart.fixer(storeData, null, false);
      BSS_B2B.handleCartCheckoutBtn(storeData);
    }, 500);
  });
 

  //fix spam checkout 
  setTimeout(() =>{
    function handleButtonClick(e) {
      e.preventDefault();
      const $button = $(this);
      let oldText = $(this).text();
      $button.css({'pointer-events': 'none', 'opacity': '0.6'});
      $button.text("Loading ...");
      setTimeout(() =>{
        $button.css({'pointer-events': 'unset', 'opacity': '1'})
          $button.text(oldText);
      }, 2000);
    }
   
   $(document).on('click dblclick', 'button[name="checkout"]', handleButtonClick);
  }, 500)

BSS_B2B.customTriggerCheckoutBtn = function(checkoutBtn){
    window.location.href = "/checkout";
  }
}

// fix translate RF
const translations = {
  "en": {
    "first_name": "First name",
    "last_name": "Last name",
    "email": "Email",
    "password": "Password",
    "radio-group-bb01649e4305f": "Are you a professional?",
    "Yes_label": "Yes",
    "No_label": "No",
    "vat-validation": "EU VAT Validation",
    "placeholder_vat": "Please leave your VAT ID here if you are a professional",
    "title_label": "Create account",
    "privacy_policy_text_1": "By clicking",
    "privacy_policy_text_2": "Submit",
    "privacy_policy_text_3": "I confirm that I have read and accepted the",
    "privacy_policy_link": "privacy policy",
    "submit_label": "Submit"
  },
  "fr": {
    "first_name": "Prénom",
    "last_name": "Nom",
    "email": "Email",
    "password": "Mot de passe",
    "radio-group-bb01649e4305f": "Êtes-vous un professionnel ?",
    "Yes_label": "Oui",
    "No_label": "Non",
    "vat-validation": "Validation de TVA européenne",
    "placeholder_vat": "Veuillez entrer votre numéro de TVA ici si vous êtes un professionnel",
    "title_label": "Créer compte",
    "privacy_policy_text_1": "En cliquant sur",
    "privacy_policy_text_2": "Créer",
    "privacy_policy_text_3": "je confirme que j'ai lu et accepté la",
    "privacy_policy_link": "politique de confidentialité",
    "submit_label": "Créer"
  },
  "nl": {
    "first_name": "Voornaam",
    "last_name": "Achternaam",
    "email": "Email",
    "password": "Wachtwoord",
    "radio-group-bb01649e4305f": "Ben je een professional?",
    "Yes_label": "Ja",
    "No_label": "Nee",
    "vat-validation": "Europese BTW-validatie",
    "placeholder_vat": "Vul hier je BTW-nummer in als je een professional bent",
    "title_label": "Maak account",
    "privacy_policy_text_1": "Door op",
    "privacy_policy_text_2": "Maak account",
    "privacy_policy_text_3": "te klikken, bevestig je dat je het",
    "privacy_policy_link": "privacybeleid",
    "submit_label": "Maak account"
  }
}

const translation = translations[Shopify.locale];

document.addEventListener("BSS_get_form_success", e => {
    BSS_B2B.rf.form.content_v2.forEach(item => {
        item.label = translation[item.id];
        if(item.id === "radio-group-bb01649e4305f") {
          item.options.forEach(option =>{
            if(option.label === "Yes") {
              option.label = translation["Yes_label"];
            }
            if(option.label === "No") {
              option.label = translation["No_label"];
            }
          })
        }
        if(item.id == "vat-validation"){
          item.help_text = translation["placeholder_vat"];
          item.placeholder = translation["placeholder_vat"];
        }
    })
});

let loop = setInterval(() => {
  let title = document.querySelector("#bss-b2b-registration-form .bss-b2b-registration-form-title h1");
  if (title) {
    clearInterval(loop);
    title.textContent = translation["title_label"];

    let privacyText = document.querySelector(".bss-b2b-rf-privacy-policy label p").innerHTML;
    privacyText = privacyText.replace("By clicking", translation["privacy_policy_text_1"]);
    privacyText = privacyText.replace("Submit", translation["privacy_policy_text_2"]);
    privacyText = privacyText.replace("I confirm that I have read and accepted the", translation["privacy_policy_text_3"]);
    privacyText = privacyText.replace("privacy policy", translation["privacy_policy_link"]);
    document.querySelector(".bss-b2b-rf-privacy-policy label p").innerHTML = privacyText;

    let inputSubmit = document.querySelector(".bss-b2b-rf-submit-button .btn");
    inputSubmit.value = translation["submit_label"];
  }
}, 300);

setTimeout(() =>{
  clearInterval(loop);
}, 7000)